import React from "react";
import {
  Box,
  Typography,
  IconButton,
  CircularProgress,
  MenuItem,
  Select,
  FormControl,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { C } from "../theme";

const selectSx = {
  height: 40,
  fontSize: 14,
  bgcolor: "#fff",
  "& .MuiOutlinedInput-notchedOutline": { borderColor: C.border },
  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: C.primary },
};

const ServiceFilters = function ServiceFilters({
  search,
  setSearch,
  tecnicoFilter,
  setTecnicoFilter,
  zonaFilter,
  setZonaFilter,
  monthFilter,
  goToPreviousMonth,
  goToNextMonth,
  tecnicos,
  servicios,
  loadingMonth = false,
  hasActiveFilters,
  resetFilters,
  filteredCount,
}) {
  const formatMonthDisplay = (monthString) => {
    if (!monthString) return "";
    const [year, month] = monthString.split("-");
    const date = new Date(year, month - 1);
    return date.toLocaleDateString("es-ES", { month: "long", year: "numeric" });
  };

  const zones = [
    ...new Set(
      servicios
        .map((s) => s.branch?.city)
        .filter((z) => z && z.trim())
    ),
  ].sort();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <IconButton
            size="small"
            onClick={goToPreviousMonth}
            disabled={loadingMonth}
            sx={{ border: `1px solid ${C.border}`, borderRadius: 2 }}
          >
            <ChevronLeftIcon fontSize="small" />
          </IconButton>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              minWidth: 180,
              justifyContent: "center",
              px: 1,
            }}
          >
            {loadingMonth && <CircularProgress size={16} sx={{ color: C.primary }} />}
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: 15,
                color: C.text,
                textTransform: "capitalize",
              }}
            >
              {formatMonthDisplay(monthFilter)}
            </Typography>
          </Box>

          <IconButton
            size="small"
            onClick={goToNextMonth}
            disabled={loadingMonth}
            sx={{ border: `1px solid ${C.border}`, borderRadius: 2 }}
          >
            <ChevronRightIcon fontSize="small" />
          </IconButton>
        </Box>

        <Typography sx={{ fontSize: 13, color: C.textSoft, fontWeight: 600 }}>
          {filteredCount} servicio{filteredCount !== 1 ? "s" : ""}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
        <Box
          sx={{
            flex: 1,
            minWidth: 200,
            height: 40,
            display: "flex",
            alignItems: "center",
            px: 1.5,
            border: `1px solid ${C.border}`,
            borderRadius: 2,
            bgcolor: "#fafafa",
          }}
        >
          <SearchIcon sx={{ fontSize: 18, color: C.textSoft }} />
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Buscar cliente, sucursal, técnico..."
            style={{
              border: "none",
              outline: "none",
              width: "100%",
              marginLeft: 8,
              fontSize: 14,
              background: "transparent",
            }}
          />
          {search && (
            <IconButton size="small" onClick={() => setSearch("")} sx={{ color: C.textSoft }}>
              <ClearIcon fontSize="small" />
            </IconButton>
          )}
        </Box>

        <FormControl size="small" sx={{ minWidth: 150 }}>
          <Select
            value={tecnicoFilter}
            onChange={(e) => setTecnicoFilter(e.target.value)}
            displayEmpty
            sx={selectSx}
          >
            <MenuItem value="">Todos los técnicos</MenuItem>
            {tecnicos.map((t) => (
              <MenuItem key={t._id} value={t._id}>
                {t.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 130 }}>
          <Select
            value={zonaFilter}
            onChange={(e) => setZonaFilter(e.target.value)}
            displayEmpty
            sx={selectSx}
          >
            <MenuItem value="">Todas las zonas</MenuItem>
            {zones.map((z) => (
              <MenuItem key={z} value={z}>
                {z}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {hasActiveFilters && (
          <IconButton
            size="small"
            onClick={resetFilters}
            sx={{ color: C.textSoft, border: `1px solid ${C.border}`, borderRadius: 2 }}
            title="Limpiar filtros"
          >
            <ClearIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default ServiceFilters;
